export const hasAnyTruthy = (obj) => Object.values(obj).some(Boolean);
